import { Component, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';

import { InvestmentWizardService } from '../services/investment-wizard-service.service';
import { MaskService } from '../../services/mask.service';

import { MaskitoDirective } from '@maskito/angular';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-fund-lookup-dialog',
  templateUrl: './fund-lookup-dialog.component.html',
  styleUrls: ['./fund-lookup-dialog.component.scss'],
  imports: [
    MaskitoDirective,
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class FundLookupDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<FundLookupDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private iws = inject(InvestmentWizardService);
  private mask = inject(MaskService);

  dollarMask = this.mask.dollarMaskSpecs();
  percentMask = this.mask.percentMaskSpecs();
  percentAllocated = 100;
  header;
  grids;
  dollarControl = new FormControl();
  percControl = new FormControl();
  investTotal;
  informationOnly = false;

  ngOnInit() {
    this.data = this.data.fund
      ? this.data
      : { fund: { FundName: null, FundID: null } };
    this.header = `${this.data.fund.FundName} | ${this.data.fund.FundID}`;
    this.investTotal = this.data.amount;
    this.iws.fundDetails(this.data.fund.FundID).subscribe(x => {
      this.grids = x.results;
    });
    this.informationOnly = this.data.mode === 'info';
  }

  cancel() {
    this.dialogRef.close({ data: 'cancel' });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  save() {
    this.data.fund.allocation =
      this.removePercentMask(this.percControl.value) / 100;
    this.dialogRef.close({ data: { fund: this.data.fund } });
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  updateValues(ev, type, field) {
    const input = field.value;
    let val;
    switch (type) {
      case 'dollar':
        val = (this.removeMoneyMask(input) / this.investTotal) * 100;

        if (input === 0 && this.percControl.value !== input) {
          this.percControl.setValue(input);
        } else if (val && this.percControl.value !== val && !isNaN(val)) {
          this.percControl.setValue(val);
        } else if (!val && this.percControl.value !== val) {
          this.percControl.setValue(0);
        }
        break;

      case 'perc':
        val = (this.removePercentMask(input) / 100) * this.investTotal;

        if (input === 0 && this.dollarControl.value !== input) {
          this.dollarControl.setValue(input);
        } else if (val && this.dollarControl.value !== val && !isNaN(val)) {
          this.dollarControl.setValue(val);
        } else if (!val && this.dollarControl.value !== val) {
          this.dollarControl.setValue(0);
        }
    }
  }

  validateTotal() {}

  removeMoneyMask(obj) {
    if (obj && typeof obj === 'string') {
      // eslint-disable-next-line no-useless-escape
      return Number(obj.replace(/\,/gi, '').replace('$', ''));
    } else if (obj && typeof obj === 'number') {
      return obj;
    }
  }

  removePercentMask(obj) {
    if (obj && typeof obj === 'string') {
      // eslint-disable-next-line no-useless-escape
      return Number(obj.replace(/\,/gi, '').replace('%', ''));
    } else {
      return obj;
    }
  }
}
